var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2913 12.2709H2.37467C2.16471 12.2709 1.96335 12.1874 1.81488 12.039C1.66642 11.8905 1.58301 11.6891 1.58301 11.4792C1.58301 11.2692 1.66642 11.0679 1.81488 10.9194C1.96335 10.7709 2.16471 10.6875 2.37467 10.6875H10.2913C10.5013 10.6875 10.7027 10.7709 10.8511 10.9194C10.9996 11.0679 11.083 11.2692 11.083 11.4792C11.083 11.6891 10.9996 11.8905 10.8511 12.039C10.7027 12.1874 10.5013 12.2709 10.2913 12.2709ZM16.6247 8.31252H2.37467C2.16471 8.31252 1.96335 8.22911 1.81488 8.08065C1.66642 7.93218 1.58301 7.73082 1.58301 7.52085C1.58301 7.31089 1.66642 7.10953 1.81488 6.96106C1.96335 6.81259 2.16471 6.72919 2.37467 6.72919H16.6247C16.8346 6.72919 17.036 6.81259 17.1845 6.96106C17.3329 7.10953 17.4163 7.31089 17.4163 7.52085C17.4163 7.73082 17.3329 7.93218 17.1845 8.08065C17.036 8.22911 16.8346 8.31252 16.6247 8.31252Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionIcon);
export default __webpack_public_path__ + "static/media/description-icon.b535c52b482a3563854599c66a10c7f1.svg";
export { ForwardRef as ReactComponent };